import { FunctionComponent } from 'react';
import { MessageDescriptor } from 'react-intl';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { MessageType, SUPPORTED_COMPONENTS } from '@savgroup-front-common/types';

import { $Breadcrumb, $BreadcrumbWrapper } from './Breadcrumb.styles';

export interface BreadcrumbItem {
  label: string | MessageType | MessageDescriptor;
  route?: string;
}

interface BreadcrumbProps {
  breadcrumbs?: BreadcrumbItem[];
}

const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({ breadcrumbs }) => {
  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <$BreadcrumbWrapper>
      {breadcrumbs.map((breadcrumb, index) => (
        <$Breadcrumb
          key={breadcrumb.label.toString()}
          $active={breadcrumbs.length - 1 === index}
          naked
          href={breadcrumb.route}
          isExternal={false}
          data-gohomepage-button
          componentThemeName={SUPPORTED_COMPONENTS.BACK_BUTTON}
          dataTestId={`breadcrumb-${index}`}
        >
          <SafeFormattedMessageWithoutSpread message={breadcrumb.label} />
        </$Breadcrumb>
      ))}
    </$BreadcrumbWrapper>
  );
};

export default Breadcrumb;
